import { render } from "./TheHeader.vue?vue&type=template&id=0bf24214&scoped=true&ts=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=0bf24214&lang=scss&scoped=true"

import exportComponent from "/Users/keita/Develop/infonic/infpf-adminsite/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf24214"]])

export default __exports__